/**
 * For maintainability we should separate controllers into their own modules
 */
angular.module('acme.view.application.membership.mapping.controllers', [
  'ui.router',
  'acme.common.service.api',
  'acme.common.service.config',
  'acme.common.factory.notice',
  'acme.common.factory.gridState',
  'acme.common.factory.gridDefinition',
  'acme.common.service.themesHelper',
  'acme.common.factory.slider'
])

.controller('MembershipMappingController', ['$scope', '$state', '$timeout', 'ApiService', 'ConfigService', 'ThemesHelperService', 'HelpersService', 'GridStateFactory', 'GridDefinitionFactory', 'NoticeFactory', 'SliderFactory', function($scope, $state, $timeout, ApiService, ConfigService, ThemesHelperService, HelpersService, GridStateFactory, GridDefinitionFactory, NoticeFactory, SliderFactory) {

    $scope.membershipMapping = {

      model: "Your spankin new application.membership.mapping view!",

      slideStepPercentage : '100%',

      containerStepPercentage : '100%',

      sliderSteps: [
        {
          stepName: 'auxiliaryEnable',
          data: 'categoryTypes',
          sliderSteps: [
            {
              stepName: 'categoryTypes',
              name: 'Choose a category',
              data: [
                {
                  stepName: 'individualAndFamily',
                  name: 'Individual & Family',
                  next: 'levelTypes',
                  id: 'individualAndFamily'
                },
                {
                  stepName: 'organization',
                  name: 'Organizations',
                  next: 'level',
                  id: 'organization'
                }
              ]
            },
            {
              stepName: 'levelTypes',
              name: 'Choose a level type',
              data: [
                {
                  stepName: 'regular',
                  name: 'Regular',
                  next: 'level',
                  id: 'regular'
                },
                {
                  stepName: 'auxiliary',
                  name: 'Auxiliary',
                  next: 'levelGroups',
                  id: 'auxiliary'
                }
              ]
            },
            {
              stepName: 'levelGroups',
              name: 'Choose a group type',
              data: '',
              callback: function() {
                $scope.membershipMapping.getLevelGroups();
              }
            },
            {
              stepName: 'level',
              name: 'Choose a level type',
              data: '',
              callback: function() {
                $scope.membershipMapping.getLevels();
              }
            },
            {
              stepName: 'offering',
              name: 'Choose an offering',
              data: '',
              callback: function() {
                $scope.membershipMapping.getOfferings();
              }
            }

          ]
        },
        {
          stepName: 'auxiliaryDisabled',
          data: 'categoryTypes',
          sliderSteps: [
            {
              stepName: 'categoryTypes',
              name: 'Choose a category type',
              data: [
                {
                  stepName: 'individualAndFamily',
                  name: 'Individual & Family',
                  next: 'level',
                  id: 'individualAndFamily'
                },
                {
                  stepName: 'organization',
                  name: 'Organizations',
                  next: 'level',
                  id: 'organization'
                }
              ]
            },
            {
              stepName: 'level',
              name: 'Choose a level type',
              data: '',
              callback: function() {
                $scope.membershipMapping.getLevels();
              }
            },
            {
              stepName: 'offering',
              name: 'Choose an offering',
              data: '',
              callback: function() {
                $scope.membershipMapping.getOfferings();
              }
            }
          ]
        }
      ],

      company: ThemesHelperService.getCompany(),

      mappingType: '',
      mode: 'view',

      viewId: $state.current.name,
      typesGridName: $state.current.name+'.grid0',
      mappedGridName: $state.current.name+'.grid1',

      addModal: {},
      offerings: [],
      types: [],
      mapped: [],

      isLoaded: false,
      isSaving: false,
      userPreferencesLoaded: false,

      selectedCategoryType: false,
      selectedCategory: false,
      selectedOffering: false,

      categoriesLoaded: false,
      categoriesGridState: new GridStateFactory(),
      categoriesGridDefinition: new GridDefinitionFactory(),

      offeringsLoaded: false,
      offeringsGridState: new GridStateFactory(),
      offeringsGridDefinition: new GridDefinitionFactory(),

      typesGridState: new GridStateFactory(),
      typesGridDefinition: new GridDefinitionFactory(),

      typesOptionsOverride: {
        enableRowSelection: true,
        enableGridMenu: false,
        useAccessibleGrid: true,
        multiSelect: true,
        noUnselect: false,
        data: 'membershipMapping.types',
        appScopeProvider: {
          onDataGridPaginate: function(newPageNumber, newPageSize) {
            $scope.membershipMapping.onTypesDataGridPaginate(newPageNumber, newPageSize);
          },
          onDataGridSortChange: function(grid, columns) {
            $scope.membershipMapping.onTypesDataGridSortChange(grid, columns);
          },
          onDataGridSelectionChange: function (row, e) {
            $scope.membershipMapping.onTypesDataGridSelectionChange(row, e);
          }
        },
        columnDefs: [
          {
            field: 'id',
            displayName: 'Id',
            visible: false
          },
          {
            field: 'level',
            displayName: 'Level',
            visible: false
          },
          {
            field: 'program',
            displayName: 'Program',
            visible: true,
            sort: {
              direction: 'asc'
            }
          },
          {
            field: 'category',
            displayName: 'Category',
            visible: true
          },
          {
            field: 'subcategory',
            displayName: 'Subcategory',
            visible: true
          }
        ]
      },

      mappedGridState: new GridStateFactory(),
      mappedGridDefinition: new GridDefinitionFactory(),

      mappedOptionsOverride: {
        enableRowSelection: true,
        enableGridMenu: false,
        useExternalPagination: false,
        useAccessibleGrid: true,
        multiSelect: false,
        noUnselect: false,
        data: 'membershipMapping.mapped',
        appScopeProvider: {
          onDataGridPaginate: function(newPageNumber, newPageSize) {
            $scope.membershipMapping.onMappedDataGridPaginate(newPageNumber, newPageSize);
          },
          onDataGridSortChange: function(grid, columns) {
            $scope.membershipMapping.onMappedDataGridSortChange(grid, columns);
          },
          onDataGridSelectionChange: function (row, e) {
            $scope.membershipMapping.onMappedDataGridSelectionChange(row, e);
          }
        },
        columnDefs: [
          {
            field: 'id',
            displayName: 'Id',
            visible: false
          },
          {
            field: 'level',
            displayName: 'Level',
            visible: false
          },
          {
            field: 'program',
            displayName: 'Program',
            visible: true,
            sort: {
              direction: 'asc'
            }
          },
          {
            field: 'category',
            displayName: 'Category',
            visible: true
          },
          {
            field: 'subcategory',
            displayName: 'Subcategory',
            visible: true
          }
        ]
      },

      gridState: new GridStateFactory(),
      notice: new NoticeFactory(),
      slider: new SliderFactory(),
      stepHistory: [],
      slideStep: '',
      isAuxEnabled: false,
      isAuxiliary:false,
      selectedLevelId: '',

      categoryName: '',

      currentGroup: '',

      init: function() {

        $scope.$emit('Application::contentTitleChange', {
          title: 'External CRM Mapping'
        });

        this.typesGridDefinition.init(this.typesGridName, this.typesOptionsOverride, this.viewId, false);
        this.mappedGridDefinition.init(this.mappedGridName, this.mappedOptionsOverride, this.viewId, false);

        this.typesGridState.updateGridState(1, null, 'program', 'asc');
        this.mappedGridState.updateGridState(1, null, 'program', 'asc');
        this.categoriesGridState.updateGridState(1, -1, 'name', 'asc');

        $scope.$on('DataGrid::UserPreferencesLoaded', this.onUserPreferencesUpdated);

        if(this.company && this.company.auxiliaryMembership) {
          this.isAuxEnabled = this.company.auxiliaryMembership;
        }
        this.slider.init(this.sliderSteps);
        this.slider.start(this.isAuxEnabled ? 'auxiliaryEnable' : 'auxiliaryDisabled');

      },

      updateSlideStep: function(step) {
        this.slideStep = 'slide' + step;
        this.slideStepPercentage = (100 / (step + 1)) + '%';
        this.containerStepPercentage = (100 * (step + 1)) + '%';
      },

      getTypes: function() {
        ApiService.membership.types.list(angular.extend({
          levelId: this.selectedLevelId,
          offeringId: this.selectedOffering.id,
          unusedTypes: true
        }, this.typesGridState.getGridState())).then(this.success.getTypes, this.error.getTypes);
      },

      getLevels: function() {

        var props = this.gridState.getGridState();
        props = HelpersService.getPaginator({ sortField: 'name', sortDirection: 'asc' });
        props.salesChannels = 'online,insideSalesIndividual,pointOfSale,reseller,manualEntry,customerRep';
        props.isPublished = '0';
        props.summarize = '1';
        props.pageSize = '-1';
        props.auxiliary = this.isAuxiliary ? '1' : '0';
        props.membershipLevelGroup = this.selectedCategoryType;
        if (this.currentGroup && this.currentGroup.id) {
          props.collectionId = this.currentGroup.id;
          if (props.excludeLevelsWithACollection) {
            delete(props.excludeLevelsWithACollection);
          }
        } else {
          props.collectionId = '';
          props.excludeLevelsWithACollection = '1';
        }

        ApiService.membership.categories.list(props).then(this.success.getLevels, this.error.getLevels);

      },

      getLevelGroups: function() {
        ApiService.membership.categories.collection.list(HelpersService.getPaginator({sortField: 'name', sortDirection: 'asc'})).then(this.success.getLevelGroups, this.error.getLevelGroups);
      },

      getOfferings: function() {
        this.offeringsLoaded = false;
        ApiService.membership.offerings.list(angular.extend({
          categoryId: this.selectedCategory.id,
          salesChannels: 'online,insideSalesIndividual,pointOfSale,reseller,manualEntry,customerRep',
          isPublished: '0'
        }, this.offeringsGridState.getGridState())).then(this.success.getOfferings, this.error.getOfferings);
      },

      next: function(stepName) {
        this.slider.getStep(stepName);
        this.updateSlideStep(this.slider.stepHistory.length - 1);
      },

      unselectCategoryType: function(stepName) {
        this.unselectCategory();
        this.currentGroup = false;
        this.offeringsLoaded = false;
        this.slider.back(stepName);
        this.updateSlideStep(this.slider.stepHistory.length - 1);
      },

      unselectCategory: function() {
        this.selectedCategory = false;
      },


      selectCategoryType: function(categoryType) {

        switch (categoryType.stepName) {
          case 'individualAndFamily' :
          case 'organization' :
            this.isAuxiliary = false;
            this.selectedCategoryType = categoryType.stepName;
            break;
          case 'auxiliary':
            this.isAuxiliary = true;
            this.selectedCategory = false;
            break;
          case 'regular':
            this.isAuxiliary = false;
            this.selectedCategory = false;
            break;
          case 'levelGroup':
            this.offeringsLoaded = false;
            this.currentGroup = categoryType;
            break;
          case 'offering':
            this.offeringsLoaded = false;
            this.selectedCategory = categoryType;
            this.selectedLevelId = categoryType.id;
            break;
        }

        if (categoryType.next) {
          this.next(categoryType.next);
        }

        if (this.offeringsLoaded) {
          this.selectOffering(categoryType);
        }
      },

      selectOffering: function(offering) {
        var foundMapped;

        this.selectedOffering = offering;
        if (this.selectedOffering.types instanceof Array) {
          this.mapped = angular.copy(this.selectedOffering.types);
        }else{
          this.mapped = [];
        }

        if (this.selectedOffering.defaultType) {
          foundMapped = this.findMapping(this.selectedOffering.defaultType.id);
          if (foundMapped) {
            this.mapped[foundMapped.index].isSelected = true;
          }
        }

        this.getTypes();
      },

      setMapping: function(type) {
        this.mappingType = type;

        if (this.isMapping('acme')) {
          // next tick
          $timeout(function() {
            var self = $scope.membershipMapping;

            $scope.$broadcast('DataGrid::ResizeGrid', {
              name: self.typesGridDefinition.options.gridName,
              datasetLength: self.types.length,
              totalItems: self.typesGridState.getPropertyValue('totalItems')
            });

            $timeout(function() {
              self.setOfferingSelections();
            }, 0);

          }, 10);

        }else if (this.isMapping('raisersEdge')) {
          // next tick
          $timeout(function() {
            var self = $scope.membershipMapping;

            $scope.$broadcast('DataGrid::ResizeGrid', {
              name: self.mappedGridDefinition.options.gridName,
              datasetLength: self.mapped.length,
              totalItems: self.mapped.length
            });

            $timeout(function() {
              self.setOfferingSelections();
            }, 0);

          }, 10);

        }

      },

      isMapping: function(type) {
        return (this.mappingType === type);
      },

      setOfferingSelections: function() {
        var i, ii,
            found;

        if (this.selectedOffering.types instanceof Array) {
          for (i = 0, ii = this.selectedOffering.types.length; i < ii; i++) {
            found = this.findType(this.selectedOffering.types[i].id);
            if (found) {
              this.types[found.index].isSelected = true;
              this.typesGridDefinition.selectRows([ this.types[found.index] ]);
            }
          }
        }

        if (this.selectedOffering.defaultType) {
          found = this.findMapping(this.selectedOffering.defaultType.id);
          if (found) {
            this.mapped[found.index].isSelected = true;
            this.mappedGridDefinition.selectRows([ this.mapped[found.index] ]);
          }
        }
      },

      isMode: function(mode) {
        return (this.mode === mode);
      },

      prepare: function() {
        var i, ii,
            j, jj,
            exists,
            defaultType,
            types = [];

        for (i = 0, ii = this.types.length; i < ii; i++) {
          exists = false;
          if (this.selectedOffering.types instanceof Array) {
            for (j = 0, jj = this.selectedOffering.types.length; j < jj; j++) {
              if (this.types[i].id === this.selectedOffering.types[j].id) {
                exists = true;
                break;
              }
            }
          }
          if (!exists && this.types[i].isSelected) {
            types.push({
              id: this.types[i].id,
              program: this.types[i].program,
              category: this.types[i].category,
              subcategory: this.types[i].subcategory
            });
          }
        }

        if (types.length) {
          if (this.selectedOffering.types instanceof Array) {
            this.selectedOffering.types = types.concat(this.selectedOffering.types);
          }else{
            this.selectedOffering.types = types;
          }
        }

        for (i = 0, ii = this.mapped.length; i < ii; i++) {
          if (this.mapped[i].isSelected) {
            defaultType = {
              id: this.mapped[i].id,
              program: this.mapped[i].program,
              category: this.mapped[i].category,
              subcategory: this.mapped[i].subcategory
            };
          }
        }

        this.selectedOffering.defaultType = defaultType;

      },

      edit: function() {
        this.mode = 'edit';
        this.typesOptionsOverride.enableRowSelection = true;
        this.mappedOptionsOverride.enableRowSelection = true;
      },

      update: function() {
        var props;

        this.isSaving = true;
        this.prepare();

        props = angular.extend(angular.copy(this.selectedOffering), { categoryId: this.selectedCategory.id });
        ApiService.membership.offerings.update(props).then(this.success.update, this.error.update);

      },

      cancel: function() {
        this.mode = 'view';
        this.typesOptionsOverride.enableRowSelection = false;
        this.mappedOptionsOverride.enableRowSelection = false;
      },

      findType: function(id) {

        var i, ii,
            r = false;

        for (i=0,ii=this.types.length;i<ii;i++) {
          if (this.types[i].id === id) {
            r = {
              types: this.types[i],
              index: i
            };
            break;
          }
        }

        return r;

      },

      findMapping: function(id) {
        var i, ii,
            r = false;

        if (this.mapped instanceof Array) {
          for (i=0, ii = this.mapped.length; i < ii; i++) {
            if (this.mapped[i].id === id) {
              r = {
                index: i,
                item: this.mapped[i]
              };
            }
          }
        }

        return r;
      },

      findModelType: function(id) {
      
        var i, ii,
            r = false;

        if (this.selectedOffering.types instanceof Array) {
          for (i = 0, ii = this.selectedOffering.types.length; i < ii; i++) {
            if (this.selectedOffering.types[i].id === id) {
              r = {
                type: this.selectedOffering.types[i],
                index: i
              };
              break;
            }
          }
        }

        return r;
        
      },
      
      success: {

        init: function(response) {},

        getTypes: function(response) {
          var self = $scope.membershipMapping;

          self.types = response.data.payload.list;

          self.typesGridDefinition.isLoaded = true;
          self.mappedGridDefinition.isLoaded = true;

          self.typesGridState.setPropertyValue('totalItems', response.data.payload.pagination.count);
          self.setMapping('acme');
        },


        getLevels: function(response) {
          var self = $scope.membershipMapping;

          self.slider.currentStep.data = response.data.payload.list;
          self.slider.currentStep.data.forEach(function (dataItem) {
            dataItem.next = 'offering';
            dataItem.stepName = 'offering';
          });
            self.categoriesLoaded = true;

        },

        getLevelGroups: function(response) {

          var self = $scope.membershipMapping;

          self.slider.currentStep.data = response.data.payload.list;
          self.slider.currentStep.data.forEach(function (dataItem) {
            dataItem.next = 'level';
            dataItem.stepName = 'levelGroup';
          });

          self.slider.currentStep.data.push({
            name: 'None',
            next: 'level',
            id: 'none'
          });

        },

        getOfferings: function(response) {

          var self = $scope.membershipMapping;

          self.offerings = response.data.payload.list;
          self.slider.currentStep.data = self.offerings;

          if (self.offerings instanceof Array && self.offerings[0]) {
            self.selectOffering(self.offerings[0]);
          }
          self.offeringsLoaded = true;
        },

        update: function(response) {
          var self = $scope.membershipMapping;

          self.isSaving = false;

          self.notice.showSuccessMessages([
            { message: 'Successfully updated' }
          ]);

          $timeout(function() {
            self.notice.hideSuccessMessages();
          }, 3000);

        }

      },

      error: {
        init: function(response) {},
        getTypes: function(response) {},

        getLevels: function(response) {
          var self = $scope.membershipMapping;
          self.categoriesLoaded = false;

        },

        getLevelGroups: function(response) {
          var self = $scope.membershipMapping;
          self.categoriesLoaded = false;

        },

        getOfferings: function(response) {
          var self = $scope.membershipMapping;

          self.offeringsLoaded = false;
        },
        update: function(response) {
          var self = $scope.membershipMapping;

          self.isSaving = false;

          self.notice.showErrorMessages([{
            message: response.data.error
          }]);
        }
      },

      onTypesDataGridPaginate: function(newPageNumber, newPageSize, sortField, sortDirection) {
        var self = $scope.membershipMapping,
            data = {
              currentPage: newPageNumber || 1,
              pageSize: newPageSize || this.typesGridDefinition.options.paginationPageSize
            };

        self.typesGridState.updateGridState(data.currentPage, data.pageSize);

        if (sortField) {
          self.typesGridState.updateGridState(null, null, sortField, null);
        }

        if (sortDirection) {
          self.typesGridState.updateGridState(null, null, null, sortDirection);
        }

        self.getTypes();
      },

      onTypesDataGridSortChange: function(grid, columns) {
        var self = $scope.membershipMapping,
            data = columns[0];

        if (data) {
          self.typesGridState.updateGridState(null, null, data.field, data.sort.direction);
          self.getTypes();
        }
      },

      onTypesDataGridSelectionChange: function(row) {
        var item,
            foundType,
            foundMapped,
            foundModelType,
            self = $scope.membershipMapping;

        foundType = self.findType(row.entity.id);

        if (foundType) {
          self.types[foundType.index].isSelected = true;
        }

        if (row.isSelected) {
          foundMapped = self.findMapping(row.entity.id);
          if (!foundMapped) {
            item = angular.copy(row.entity);
            item.isSelected = false;
            self.mapped.push(item);
          }
        } else {
          foundModelType = self.findModelType(row.entity.id);
          foundMapped = self.findMapping(row.entity.id);
          row.entity.isSelected = false;
          if (this.selectedOffering.types instanceof Array) {
            self.selectedOffering.types.splice(foundModelType.index, 1);
          }
          if (foundMapped) {
            if (self.selectedOffering.defaultType && self.selectedOffering.defaultType.id) {
              if (foundMapped.id === self.selectedOffering.defaultType.id) {
                self.selectedOffering.defaultType = null;
                delete self.selectedOffering.defaultType;
              }
            }
            self.mapped.splice(foundMapped.index, 1);
          }
        }

      },

      onMappedDataGridPaginate: function(newPageNumber, newPageSize, sortField, sortDirection) {
        var self = $scope.membershipMapping,
            data = {
              currentPage: newPageNumber || 1,
              pageSize: newPageSize || this.mappedGridDefinition.options.paginationPageSize
            };

        self.mappedGridState.updateGridState(data.currentPage, data.pageSize);

        if (sortField) {
          self.mappedGridState.updateGridState(null, null, sortField, null);
        }

        if (sortDirection) {
          self.mappedGridState.updateGridState(null, null, null, sortDirection);
        }

      },

      onMappedDataGridSortChange: function(grid, columns) {
        var self = $scope.membershipMapping,
            data = columns[0];

        if (data) {
          self.mappedGridState.updateGridState(null, null, data.field, data.sort.direction);
        }
      },

      onMappedDataGridSelectionChange: function(row) {
        var self = $scope.membershipMapping,
            found = self.findMapping(row.entity.id);

        if (found) {
          this.mapped[found.index].isSelected = row.isSelected;
        }
      },

      onUserPreferencesUpdated: function() {
        var self = $scope.membershipMapping,
            props = self.typesGridDefinition.getGridState();

        self.typesGridState.updateGridState(props.page, props.pageSize, props.sortField, props.sortDirection);
        self.getTypes();
      }

    };

    $scope.membershipMapping.init();

}]);